import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { api_routes } from '@app/consts';
import { EmployeeRelocationSubmit, EmployeeRelocationVerbose } from '../models/employee-relocation.model';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class EmployeeRelocationService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getRelocations(employeeId: string, take?: number, skip?: number, sort?: string): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;
    sort ? params = params.append('sort', sort) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.RELOCATIONS}`, {
      headers: headers,
      params: params
    })
    .pipe(
      catchError(err => throwError(err)),
      map(res => {
        let data = {
          data: res.data,
          total: res.total
        }

        return data;
      })
    );
  }

  deleteRelocation(employeeId: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.RELOCATIONS}/${id}`, {
      headers: headers
    });
  }

  getRelocation(employeeId: string, id: string): Observable<EmployeeRelocationVerbose> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.RELOCATIONS}/${id}`, {
      headers: headers
    });
  }

  updateRelocation(employeeId: string, employeeRelocation: EmployeeRelocationSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.RELOCATIONS}/${employeeRelocation.id}`, employeeRelocation, {
      headers: headers
    });
  }

  createRelocation(employeeId: string, employeeRelocation: EmployeeRelocationSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.RELOCATIONS}`, employeeRelocation, {
      headers: headers
    });
  }
}

